function setTableHeight (row, height, isTab) {
  let delHeight = row === 1 ? 186 : row === 2 ? 228 : row === 3 ? 270 : height
  if (isTab) delHeight += 48
  const clientHeight = document.body.clientHeight
  return clientHeight - delHeight
}

export default {
  setTableHeight
}
